var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevrone"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 6,
    fill: "#F0EFF3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.9997 11.1697C18.8123 10.9834 18.5589 10.8789 18.2947 10.8789C18.0305 10.8789 17.7771 10.9834 17.5897 11.1697L13.9997 14.7097L10.4597 11.1697C10.2723 10.9834 10.0189 10.8789 9.7547 10.8789C9.49052 10.8789 9.23707 10.9834 9.0497 11.1697C8.95598 11.2627 8.88158 11.3733 8.83081 11.4951C8.78004 11.617 8.75391 11.7477 8.75391 11.8797C8.75391 12.0117 8.78004 12.1424 8.83081 12.2643C8.88158 12.3861 8.95598 12.4967 9.0497 12.5897L13.2897 16.8297C13.3827 16.9234 13.4933 16.9978 13.6151 17.0486C13.737 17.0994 13.8677 17.1255 13.9997 17.1255C14.1317 17.1255 14.2624 17.0994 14.3843 17.0486C14.5061 16.9978 14.6167 16.9234 14.7097 16.8297L18.9997 12.5897C19.0934 12.4967 19.1678 12.3861 19.2186 12.2643C19.2694 12.1424 19.2955 12.0117 19.2955 11.8797C19.2955 11.7477 19.2694 11.617 19.2186 11.4951C19.1678 11.3733 19.0934 11.2627 18.9997 11.1697Z",
    fill: "#464167"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevrone);
export default __webpack_public_path__ + "static/media/chevrone.4d47ef62092a110eaaebb647f6b1a154.svg";
export { ForwardRef as ReactComponent };